import Formatter from 'accounting'

export default (number, props) => {
  return Formatter.formatNumber(number, {
    precision: props.precision,
    decimal: props.decimal,
    thousand: props.thousand,
  }) + '%'
}
